export default "__VITE_ASSET__eILOz3SH__";